var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApplicationTableCustomField',{attrs:{"fieldType":"locality","items":_vm.dataObj.item.form.real_estate_target}})}
var staticRenderFns = []

export { render, staticRenderFns }